import { ListResponse, PostModel } from "common/models/baseModel";
import api from "utils/api";
import { endpoints } from "utils/endpoints";

import { createQueryKeys } from "@lukemorales/query-key-factory";
import { ICourse, ICourseGridFilter, ICourseGridModel } from "./types";
import { courseView } from "../types/courseView";
import { IDropdownModel } from "common/models/IDropdownModel";

export const course = createQueryKeys("course", {
  list: (postModel: PostModel<ICourseGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<ListResponse<ICourseGridModel>>(
        endpoints.course.list,
        postModel
      ),
  }),
  get: (id: number) => ({
    queryKey: [id],
    queryFn: () => api.get<ICourse>(`${endpoints.course.get}/${id}`),
  }),
  view: (id: number) => ({
    queryKey: [id],
    queryFn: () => api.get<courseView>(`${endpoints.course.view}/${id}`),
  }),
  courseValues: {
    queryKey: null,
    queryFn: () =>
      api.get<IDropdownModel[]>(`${endpoints.course.courseValues}`),
  },
});
